import React from 'react'
import { useAuth, hasAuthParams } from "react-oidc-context";
import { LoadingComponent } from 'usbc-web-react-library';

function PrivateLayout(props) {
    const auth = useAuth();

    React.useEffect(() => {
        return auth.events.addSilentRenewError(() => {
            auth.signinRedirect({
                state: window.location.href,
                extraQueryParams: { app_path: window.location.pathname }
            });
        })
    }, [auth.events, auth.signinSilent]);

    React.useEffect(() => {
        if (!hasAuthParams() &&
            !auth.isAuthenticated && !auth.activeNavigator && !auth.isLoading) {
            auth.signinRedirect({
                state: window.location.href,
                extraQueryParams: { app_path: window.location.pathname }
            });
        }
    }, [auth.isAuthenticated, auth.activeNavigator, auth.isLoading, auth.signinRedirect]);


    return (
        <>
            {(auth.isLoading === false) &&
                props.children
            }

            <LoadingComponent isLoading={() => auth.isLoading === true}
                description={!auth.activeNavigator ? "Signing you in" : auth.activeNavigator === "signinRedirect" ? "Redirecting to login page" : "Signing you out"}>
            </LoadingComponent>
        </>
    )
}

export default PrivateLayout